import { Skeleton, Stack } from '@chakra-ui/react';
import React from 'react';

const ProductCardLoader = () => {
  return (
    <Stack p={4} border={'1px solid #ccc'}>
      <Skeleton height="200px" rounded={'md'} />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
      <Skeleton height="20px" />
    </Stack>
  );
};

export default ProductCardLoader;
